import { NgModule } from '@angular/core';
import { MediaModalComponent } from './media-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [
    MediaModalComponent
  ],
  imports: [
    MatDialogModule,
    SharedModule
  ],
  entryComponents: [MediaModalComponent]
})
export class MediaModalModule { }
